import React from 'react'
import styleProvider from '@quotatisgroup/uikit-public.style-provider'
import cx from 'classnames'
import './buttonStyle.scss'

export type ButtonProps = JSX.IntrinsicElements['button'] & {
  className?: string
  classes?: string
  children: JSX.Element | string
  type?: 'button' | 'submit' | 'reset'
  variant?:
    | 'basic'
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'success'
    | 'warning'
    | 'info'
    | 'grey'
    | 'white'
    | 'control'
  size?: 'lg' | 'full' | 'md' | 'xl' | 'xs' | 'sm'
  icon?: string
  iconPosition?: 'right' | 'left'
  hasBorder?: boolean
  hasLinkStyle?: boolean
  fullWidth?: boolean
  isLoading?: boolean
  handleClick?: () => void
  id?: string
  disabled?: boolean
}

const ButtonComponent = ({
  className,
  classes,
  children,
  type = 'button',
  variant = 'primary',
  size = 'sm', 
  icon,
  iconPosition,
  hasBorder = false,
  hasLinkStyle = false,
  fullWidth = false,
  isLoading = false,
  handleClick,
  id,
  ...otherProps
}: ButtonProps) => {
  return (
    <button
      id={id}
      type={type}
      className={cx(
        classes,
        `btn-${variant}`,
        {
          [`btn-${size}`]: size,
          btn: !size,
          [`hasBorder`]: hasBorder,
          [`hasLinkStyle`]: hasLinkStyle,
          [`fullWidth`]: fullWidth,
          [`icon-${iconPosition}`]: iconPosition,
        },
        className,
      )}
      onClick={handleClick}
      {...otherProps}
    >
      {isLoading ? (
        <img
          src="https://res.cloudinary.com/quotatis/image/upload/FrontApp/vitrine/icon/spinner.svg"
          className="loader"
          alt="loader icon"
        />
      ) : (
        <>
          {icon && (
            <img
              className="icon-link"
              src={`https://res.cloudinary.com/quotatis/image/upload/FrontApp/vitrine/icon/${icon}.svg`}
              alt="icon"
            />
          )}
          {children}
        </>
      )}
    </button>
  )
}

export const Button = styleProvider(ButtonComponent)
